import { AbstractControl } from '@angular/forms';
import {
  TypedFormArray,
  TypedFormControl,
  TypedFormGroup,
} from 'ngx-forms-typed';
import { defer, Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

export function valuesOf<T>(control: TypedFormControl<T>): Observable<T>;
export function valuesOf<T>(control: TypedFormGroup<T>): Observable<T>;
export function valuesOf<T>(control: TypedFormArray<T[], T>): Observable<T[]>;
export function valuesOf<T>(control: AbstractControl): Observable<T | null>;
export function valuesOf(control: AbstractControl): Observable<any> {
  return defer(() => control.valueChanges.pipe(startWith(control.value)));
}
